const ARRAY = "[object Array]";
const BOOLEAN = "[object Boolean]";
const NULL = "[object Null]";
const NUMBER = "[object Number]";
const OBJECT = "[object Object]";
const STRING = "[object String]";
const UNDEFINED = "[object Undefined]";

const PROTOTYPES = {
  ARRAY,
  BOOLEAN,
  NULL,
  NUMBER,
  OBJECT,
  STRING,
  UNDEFINED,
};

export { PROTOTYPES };
